import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

// TODO: convert to FC
class ZendeskLogoutComponent extends React.Component<RouteComponentProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    fetch(/*'https://localhost:8443*/ '/api/v1/zendesk/access/dispatchlogout', {
      method: 'POST',
      redirect: 'follow',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ urlSearch: this.props.location.search }),
    })
      .then((res) =>
        res.json().then((json) => {
          window.location.href = json.location;

          return null;
        }),
      )
      .catch((error) => {
        // Assuming users are coming from the PROD environment (why?)
        window.location.href = 'https://affiliates.expediagroup.com/signout';

        return null;
      });

    return null;
  }
}

export const ZendeskLogoutExecutor = withRouter(ZendeskLogoutComponent);
